import React from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import SyncIcon from "@mui/icons-material/Sync";

function WidgetSyncScreensDialog({ open, isSyncing, onClose, onConfirm }) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={() => !isSyncing && onClose()}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px",
          overflow: "visible",
        },
      }}
    >
      <IconButton
        onClick={() => onClose()}
        disabled={isSyncing}
        sx={{
          position: "absolute",
          top: -16,
          right: -16,
          bgcolor: "background.paper",
          boxShadow: 3,
          "&:hover": { bgcolor: "background.paper" },
        }}
        size="small"
      >
        <CloseIcon fontSize="small" />
      </IconButton>

      <DialogContent sx={{ pt: 5, pb: 3, px: 4 }}>
        <Stack spacing={2} alignItems="center" textAlign="center">
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: (theme) => theme.palette.primary.main + "1a",
              color: "primary.main",
            }}
          >
            <SyncIcon fontSize="large" />
          </Box>
          <Typography variant="h6" fontWeight={700}>
            {t("views.redesignFile.syncScreensTitle", "Sync screens?")}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t(
              "views.redesignFile.syncScreensDescription",
              "Do you want to sync screens on which this widget is displayed (including screens with a playlist containing this file)?"
            )}
          </Typography>
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 4, pb: 4, pt: 0, gap: 1 }}>
        <Button
          fullWidth
          variant="outlined"
          disabled={isSyncing}
          onClick={() => onClose()}
          sx={{ borderRadius: "10px", textTransform: "capitalize", py: 1 }}
        >
          {t("components.confirmationModel.no", "No")}
        </Button>
        <Button
          fullWidth
          variant="contained"
          disableElevation
          disabled={isSyncing}
          onClick={() => onConfirm()}
          startIcon={isSyncing ? <CircularProgress size={16} color="inherit" /> : null}
          sx={{ borderRadius: "10px", textTransform: "capitalize", py: 1 }}
        >
          {isSyncing
            ? t("views.redesignFile.syncing", "Syncing...")
            : t("components.confirmationModel.yes", "Yes")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default WidgetSyncScreensDialog;
